const STORAGE_KEY = "bj-basket-v1";

export type BasketLine = {
  productId: string;
  quantity: number;
};

export function readBasket(): BasketLine[] {
  if (typeof window === "undefined") {
    return [];
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return [];
    }

    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed.filter(isBasketLine);
  } catch {
    return [];
  }
}

export function writeBasket(lines: BasketLine[]): void {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(lines));
}

function isBasketLine(value: unknown): value is BasketLine {
  if (typeof value !== "object" || value === null) {
    return false;
  }

  const line = value as Partial<BasketLine>;
  return (
    typeof line.productId === "string" &&
    typeof line.quantity === "number" &&
    Number.isInteger(line.quantity) &&
    line.quantity > 0
  );
}
